import React from "react";
import { Button, Row, Col, Modal, ModalBody, ModalFooter, FormGroup } from "reactstrap";
import Select from 'react-select';
import { isIOS, isMobileSafari, withOrientationChange, isMacOs} from 'react-device-detect';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { getMessage } from "CONFIG/i18n";
import { headerAction, sessionActions } from "CONFIG/ActionFactory";

import "./Preview.less";

// Constants
import { CALLING_PREVIEW, FILTER_NAME, FILTER_CONFIG, BANDWIDTH_MANAGEMENT_LIST, BANDWIDTH_IDX_LOW, DEFAULT_FPS } from "UTILS/Constants";
import { getUserMediaError, getMediaConstraints, isMobileOriPad } from "UTILS/Utility";
import { mediaType, mediaStatus } from "WEBSOCKET/constants";
import { DEVICE_ORIENTATION, USER_ROLES, SESSION_SUBTYPES } from 'UTILS/Constants';

import Switch from "COMPONENTS/CommonComponents/Switch/Switch";
import modalScrollBar from "COMPONENTS/ModalScrollBar/ModalScrollBar";
import toastr from 'COMPONENTS/ShowTostr/ShowTostr';
import { VirtualBackgroundFilter } from "COMPONENTS/CommonComponents/VirtualBackground/VirtualBackground";

import { socketMessage } from "WEBSOCKET/constants";
import { sendWebsocketMessage } from "WEBSOCKET/WebsocketHandler";

// Selector
import { getVideoBandwidthSettings } from  "../selectors";
import { getDeviceOrientation } from '@/Redux/Selector/UserSelector';
import { selectUserRole } from "../../Whiteboard/selectors";
import { selectSessionKey } from "REDUX/Selector/SessionSelector"
import { getSpeedTestParticipantId, getSpeedTestExecutedFlag } from "REDUX/Selector/RoomMetaDataSelector"
import { selectCurrentParticipantUniqueId, getIsPreviewResize } from "REDUX/Selector/SessionSelector";
import { selectUserName, getAllParticipants } from "COMPONENTS/CommonComponents/Header/selectors";

// Images
import audio_off from "ASSETS/Images/video_menu/ic_audio_off_small_transparent.svg";
import audio_on from "ASSETS/Images/video_menu/ic_audio_on_small_transparent.svg";
import video_on from "ASSETS/Images/video_menu/ic_video_on_small_transparent.svg";
import video_off from "ASSETS/Images/video_menu/ic_video_off_small_transparent.svg";
import icBar from "ASSETS/Images/ic_bar.svg";
import ic_switch_camera from "ASSETS/Images/video_menu/ic_camera_switch.svg";
import bg1 from "ASSETS/Images/virtualbg/bg1.webp";
import bg2 from "ASSETS/Images/virtualbg/bg2.webp";
import bg3 from "ASSETS/Images/virtualbg/bg3.webp";

import Popup from "COMPONENTS/CommonComponents/Modal/Modal";
import SpeedTest from "./SpeedTest";

class PreviewModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      previewAudio: true,
      previewVideo: false,
      previewReverse: false,
      previewVirtualBackground: false,
      isAudioDeviceDisable: false,
      isVideoDeviceDisable: false,
      audioDeviceList: [],
      videoDeviceList: [],
      facingMode: 'user',
      selectedAudioDevice: null,
      selectedVideoDevice: null,
      selectedBackground: FILTER_NAME.BLUR,
      showSpeedTestConfirmPopUpFlag: false,
      isSpeedTestRunning: false,
    };
    this.mediaStream = null;
    this.mediaStreamTrack = null;
    this.virtualBackgroundFilter = null;
    this.closeModal = false;
  }

  async componentDidUpdate(prevProps, prevState) {
    if (this.props.show && prevProps.show !== this.props.show) {
      const selectedBackground =  this.props.currentSelectedBackground ? this.props.currentSelectedBackground : FILTER_NAME.BLUR;
      if (this.props.currentVirtualBackground && this.props.currentSelectedBackground) {
        if ( !this.virtualBackgroundFilter ) {
          const virtualBackgroundFilter = new VirtualBackgroundFilter(FILTER_CONFIG[selectedBackground]);
          this.virtualBackgroundFilter = virtualBackgroundFilter;
        } else {
          this.virtualBackgroundFilter.setBackground(FILTER_CONFIG[selectedBackground]);
        }
      }
      this.closeModal = false;
      this.setState({
        previewAudio: this.props.currentAudioStatus === mediaStatus.MUTED ? false : true,
        previewVideo: this.props.currentVideoStatus === mediaStatus.MUTED ? false : true,
        previewReverse: this.props.currentReverse ? this.props.currentReverse : false,
        previewVirtualBackground: this.props.currentVirtualBackground ? this.props.currentVirtualBackground : false,
        selectedBackground,
        isAudioDeviceDisable: false,
        isVideoDeviceDisable: false,
        facingMode:  this.props.currentFacingMode ? this.props.currentFacingMode : 'user',
      });
      if (this.props.sessionType === SESSION_SUBTYPES.SUPPORT_CENTER) {
        await this.getDevice();
        await this.startAudioStream();
      }
    }

    if (this.state.isSpeedTestRunning &&
      (this.props.speedTestParticipantId !== prevProps.speedTestParticipantId) &&
      !this.props.speedTestParticipantId) {
      this.setState({isSpeedTestRunning: false});
    }
  }

  componentWillUnmount() {
    this.virtualBackgroundFilter && this.virtualBackgroundFilter.destroy();
  }

  renderSwitch = (flag, variable, isDisable = false) => {
    return (
      <Switch
        switchOn={flag}
        toggleSwitch={(event) => {
          this.handleSwitches(event, variable);
        }}
        className="modal-label"
        disabled={isDisable}
      />
    );
  }

  stopVideoStream = async () => {
    if ( this.mediaStreamTrack ) {
      this.mediaStreamTrack.stop();
      const videoElement = document.getElementById(CALLING_PREVIEW.PREVIEW_VIDEO);
      if ( videoElement && videoElement.srcObject ) videoElement.srcObject = null;
    }
    this.mediaStreamTrack = null;
    this.mediaStream = null;
  }

  handleSwitches = async (toggleFlag, variable) => {
    this.setState({ [variable]: toggleFlag });
    switch (variable) {
      case CALLING_PREVIEW.PREVIEW_AUDIO:
        if (toggleFlag && this.props.sessionType === SESSION_SUBTYPES.SUPPORT_CENTER) {
          await this.startAudioStream();
        }
        break;
      case CALLING_PREVIEW.PREVIEW_VIDEO:
        if (toggleFlag) {
          await this.startVideoStream();
        } else {
          this.virtualBackgroundFilter && await this.virtualBackgroundFilter.stop();
          await this.stopVideoStream();
          this.setState({ [CALLING_PREVIEW.PREVIEW_REVERSE]: false });
          this.setState({ [CALLING_PREVIEW.PREVIEW_VIRTUAL_BACKGROUND]: false });
          await this.transformVideo(false);
        }
        break;
      case CALLING_PREVIEW.PREVIEW_REVERSE:
        headerAction.setVideoTransform(toggleFlag);
        await this.transformVideo(toggleFlag);
        break;
      case CALLING_PREVIEW.PREVIEW_VIRTUAL_BACKGROUND:
        await this.setVirtualBackground(toggleFlag);
        break;
    }
  }

  getDevice = async () => {
    let audioDeviceList = [];
    let videoDeviceList = [];
    await navigator.mediaDevices.enumerateDevices().then(devices => {
      audioDeviceList = devices.filter((device, index, self) => {
        if (device.kind === "audioinput") {
          return device;
        }
      });
      videoDeviceList = devices.filter((device, index, self) => {
        if (device.kind === "videoinput") {
          return device;
        }
      });
    });
    if (!isIOS && !isMacOs) {
      audioDeviceList = audioDeviceList.filter((device, index, self) => {
        const groupIdList = self.map(device => device['groupId']);
        if (groupIdList.indexOf(device.groupId) === index) {
          return device;
        }
      });
      videoDeviceList = videoDeviceList.filter((device, index, self) => {
        const groupIdList = self.map(device => device['groupId']);
        if (groupIdList.indexOf(device.groupId) === index) {
          return device;
        }
      });
    }
    let selectedAudioDevice = audioDeviceList?.[0];
    let selectedVideoDevice = videoDeviceList?.[0];
    if (this.props.currentAudioDeviceId) {
      selectedAudioDevice = audioDeviceList.find(device => device.deviceId == this.props.currentAudioDeviceId);
    }
    if (this.props.currentVideoDeviceId) {
      selectedVideoDevice = videoDeviceList.find(device => device.deviceId == this.props.currentVideoDeviceId);
    }
    this.setState({
      audioDeviceList,
      videoDeviceList,
      selectedAudioDevice,
      selectedVideoDevice,
    });
  }

  startAudioStream = async () => {
    this.setState({isLoadingAudioStream: true});
    // Run lazily for state updates
    setTimeout(() => {
      if (!this.state.previewAudio || this.closeModal) {
        this.setState({isLoadingAudioStream: false});
        return;
      }
      if (this.state.audioDeviceList.length <= 0) {
        toastr.error(getMessage("MIC_NOT_CONNECTED"));
        this.setState({
          isAudioDeviceDisable: true,
          isLoadingAudioStream: false,
        });
        return;
      }
      // getUserMedia
      const constraintsSettings = {
        media: mediaType.AUDIO,
      };
      if(!isMobileOriPad()) {
        constraintsSettings.audioDeviceId = this.state.selectedAudioDevice?.deviceId;
      }
      const constraints = getMediaConstraints(constraintsSettings);
      navigator.mediaDevices.getUserMedia(constraints)
      .then(stream => {
        this.setState({isAudioDeviceDisable: false});
        stream && stream.getTracks().forEach(track => {
          track.stop();
        });
      })
      .catch((error) => {
        const errorMessage = getUserMediaError(error, mediaType.AUDIO);
        if (errorMessage) {
          toastr.error(getMessage(errorMessage));
        }
        this.setState({isAudioDeviceDisable: true});
      })
      .finally(() => {
        this.setState({isLoadingAudioStream: false});
      });
    }, 300);
  }

  virtualBackgroundErrorHandler = async (error) => {
    toastr.error(getMessage("VIRTUAL_BACKGROUND_FAILED"));
    this.setState({ [CALLING_PREVIEW.PREVIEW_VIRTUAL_BACKGROUND]: false });
    const videoElement = document.getElementById(CALLING_PREVIEW.PREVIEW_VIDEO);
    if (videoElement) { videoElement.srcObject = this.mediaStream; }
  }

  applyVirtualBackground = async (videoElement, stream) => {
    await this.virtualBackgroundFilter.getFilteredStream(stream, this.virtualBackgroundErrorHandler).then((filterStream) => {
      videoElement.srcObject = filterStream;
    }).catch(async (error) => {
      console.error(error);
      await this.virtualBackgroundFilter.stop();
      if (!this.closeModal) {
        toastr.error(getMessage("VIRTUAL_BACKGROUND_FAILED"));
        this.setState({ [CALLING_PREVIEW.PREVIEW_VIRTUAL_BACKGROUND]: false });
      }
    });
  }

  startVideoStream = async () => {
    this.setState({isLoadingVideoStream: true});
    // Run lazily for state updates
    setTimeout(() => {
      if (!this.state.previewVideo || this.closeModal ) {
        this.setState({isLoadingVideoStream: false});
        return;
      }
      if (this.state.videoDeviceList.length <= 0) {
        // toastr.error(getMessage("WEBCAM_NOT_CONNECTED"));
        this.setState({
          isVideoDeviceDisable: true,
          isLoadingVideoStream: false,
        });
        return;
      }
      // getUserMedia
      const videoBandwidthSettings = {
        module: this.props.videoBandwidthSettings?.module,
        bandwidth: BANDWIDTH_MANAGEMENT_LIST[BANDWIDTH_IDX_LOW].value,
        fps: this.props.videoBandwidthSettings?.fps > DEFAULT_FPS ? DEFAULT_FPS : this.props.videoBandwidthSettings?.fps,
      }
      const constraintsSettings = {
        media: mediaType.VIDEO,
        videoBandwidthSettings: videoBandwidthSettings,
        isLandscape: this.props.isLandscape,
        isVirtualBackground: this.state.previewVirtualBackground,
      };
      if(isMobileOriPad()) {
        constraintsSettings.facingMode = this.state.facingMode;
      } else {
        constraintsSettings.videoDeviceId = this.state.selectedVideoDevice?.deviceId;
      }
      const constraints = getMediaConstraints(constraintsSettings);
      navigator.mediaDevices.getUserMedia(constraints)
      .then(stream => {
        this.setState({isVideoDeviceDisable: false});
        stream && stream.getTracks().forEach(async (track) => {
          const videoElement = document.getElementById(CALLING_PREVIEW.PREVIEW_VIDEO);
          if ( videoElement && !this.closeModal ) {
            if (this.mediaStreamTrack ) {
              this.mediaStreamTrack.stop();
            }
            this.mediaStream = stream;
            this.mediaStreamTrack = track;
            if (this.state.previewVirtualBackground) {
              await this.applyVirtualBackground(videoElement, stream );
            } else {
              videoElement.srcObject = stream;
            }
            videoElement.play().then(() => {
              ;
            }).catch((error) => {
              console.error(error);
              track.stop();
              this.mediaStreamTrack = null;
              this.mediaStream = null;
              return;
            });
          } else {
            track.stop();
          }
        });
      })
      .catch((error) => {
        const errorMessage = getUserMediaError(error, mediaType.VIDEO);
        if (errorMessage) {
          toastr.error(getMessage(errorMessage));
        }
        this.setState({isVideoDeviceDisable: true});
      })
      .finally(async () => {
        this.setState({isLoadingVideoStream: false});
        if ( this.mediaStreamTrack && this.closeModal ) {
          await this.stopVideoStream();
        }
      });
    }, 300);
  }

  transformVideo = async (toggleFlag) => {
    const videoElement = document.getElementById(CALLING_PREVIEW.PREVIEW_VIDEO);
    if (toggleFlag) {
      videoElement.style.transform = "scale(1)";
    } else {
      videoElement.style.transform = "";
    }
  }

  setVirtualBackground = async (toggleFlag) => {
    const videoElement = document.getElementById(CALLING_PREVIEW.PREVIEW_VIDEO);
    if (toggleFlag) {
      if ( !this.virtualBackgroundFilter ) {
        this.virtualBackgroundFilter = new VirtualBackgroundFilter(FILTER_CONFIG[this.state.selectedBackground]);
      } else {
        this.virtualBackgroundFilter.setBackground(FILTER_CONFIG[this.state.selectedBackground]);
      }
      if (!( this.state.previewVideo && this.mediaStream && this.mediaStreamTrack ) || this.closeModal ) return;
      await this.virtualBackgroundFilter.stop();
      await this.stopVideoStream();
      await this.startVideoStream();
    } else {
      await this.virtualBackgroundFilter.stop();
      videoElement.srcObject = this.mediaStream;
    }
  }

  handleCancelClick = async () => {
    this.closeModal = true;
    this.virtualBackgroundFilter && await this.virtualBackgroundFilter.stop();
    await this.stopVideoStream();
    if (isMobileSafari) {
      if (this.props.isStart) {
        this.props.handlePreviewModalCancelClick();
      } else {
        this.props.handlePreviewModalStartClick(
          this.props.currentAudioStatus === mediaStatus.MUTED ? false : true,
          this.props.currentVideoStatus === mediaStatus.MUTED ? false : true,
          this.props.currentReverse,
          this.props.currentAudioDeviceId,
          this.props.currentVideoDeviceId,
          this.props.currentFacingMode,
          this.props.currentVirtualBackground,
          this.props.currentSelectedBackground,
        );
      }
    } else {
      this.props.handlePreviewModalCancelClick();
    }
  };

  handleStartClick = async () => {
    this.closeModal = true;
    this.virtualBackgroundFilter && await this.virtualBackgroundFilter.stop();
    await this.stopVideoStream();
    this.props.handlePreviewModalStartClick(
      this.state.previewAudio,
      this.state.previewVideo,
      this.state.previewReverse,
      this.state.selectedAudioDevice?.deviceId,
      this.state.selectedVideoDevice?.deviceId,
      this.state.facingMode,
      this.state.previewVirtualBackground,
      this.state.selectedBackground,
    );
  };

  handleAudioDeviceChange = async (selectedDevice) => {
    const selectedAudioDevice = this.state.audioDeviceList.find((audioDevice) => {
      return audioDevice.deviceId === selectedDevice.value;
    });
    if (selectedAudioDevice) {
      this.setState({ selectedAudioDevice});
      await this.startAudioStream();
    }
  }

  handleVideoDeviceChange = async (selectedDevice) => {
    const selectedVideoDevice = this.state.videoDeviceList.find((videoDevice) => {
      return videoDevice.deviceId === selectedDevice.value;
    });
    if (selectedVideoDevice) {
      this.setState({ selectedVideoDevice });
      if ( this.virtualBackgroundFilter ) {
        await this.virtualBackgroundFilter.stop();
      }
      await this.stopVideoStream();
      await this.startVideoStream();
    }
  }

  convertToOption = (device) => {
    let options = {};
    if (device) {
      options = {
        label: device.label,
        value: device.deviceId
      };
    }
    return options;
  }

  handleSwitchCamera = async () =>{
    const facingMode = this.state.facingMode == 'user' ? 'environment' : 'user';
    this.setState({facingMode});
    if ( this.virtualBackgroundFilter ) {
      await this.virtualBackgroundFilter.stop();
    }
    await this.stopVideoStream();
    await this.startVideoStream();
  }

  handleSetBackgroundImage = async (bgImage) =>{
    if (!this.state.previewVirtualBackground || this.state.isLoadingVideoStream) {
      return
    }
    const selectedBackground = bgImage;
    this.setState({selectedBackground});
    if (this.virtualBackgroundFilter){
      this.virtualBackgroundFilter.setBackground(FILTER_CONFIG[bgImage]);
    }
  }

  execSpeedTest = () => {
    const payload = {
      data: {
        category: socketMessage.category.SESSION,
        action: socketMessage.subCategories.SESSION.EXEC_SPEED_TEST,
        sessionKey: this.props.sessionKey,
        remoteId: this.props.uniqueId,
        name: this.props.userName,
      }
    };
    sendWebsocketMessage(
      socketMessage.events.MESSAGE,
      payload
    )();
  }

  handleRerunSpeedtTest = () => {
    this.setState({ showSpeedTestConfirmPopUpFlag: true });
  }

  showSpeedTestPermissionPopUp = () => {
    return (
      <Popup
        show={this.state.showSpeedTestConfirmPopUpFlag}
        isDoubleButton={true}
        handleYesClick={this.handleSpeedTestConfirmYesClick}
        handleNoClick={this.handleSpeedTestConfirmNoClick}
        message={getMessage("SPEED_TEST_START_CONFIRM_MESSAGE")}
        isPermissionPopup={false}
      />
    );
  }

  handleSpeedTestConfirmYesClick = () => {
    this.setState({ 
      isSpeedTestRunning: true,
      showSpeedTestConfirmPopUpFlag: false
    });
    this.execSpeedTest();
  }

  handleSpeedTestConfirmNoClick = () => {
    this.setState({ showSpeedTestConfirmPopUpFlag: false });
  }

  renderMicrophoneIconAndSwitch = () => {
    return (
      <React.Fragment>
        {this.showSpeedTestPermissionPopUp()}
        <div className="d-flex modal-label mr-2">
          <img
            src={this.state.previewAudio ? audio_on : audio_off}
            className="previewSwitch"
          />
        </div>
        <div className="d-flex modal-label">
          {this.renderSwitch(this.state.previewAudio, CALLING_PREVIEW.PREVIEW_AUDIO)}
        </div>
      </React.Fragment>
    );
  }

  renderMicrophone = () => {
    return (
      <React.Fragment>
        <Row className="previewSetting mb-1 mx-0">
          <label className="label modal-label mr-4 mb-0">{getMessage("MICROPHONE")}</label>
          {isMobileOriPad() && !this.props.isLandscape && this.renderMicrophoneIconAndSwitch()}
        </Row>
        { (!isMobileOriPad() || isMobileOriPad() && this.props.isLandscape ) &&
          <Row className="previewSetting mx-0 previewSettingIndent">
            {this.renderMicrophoneIconAndSwitch()}
            {!isMobileOriPad() &&
              <div className="d-flex modal-label previewSelectDevice">
                <Select className="w-100"
                  value={this.convertToOption(this.state.selectedAudioDevice)}
                  onChange={this.handleAudioDeviceChange}
                  options={this.state.audioDeviceList.map(this.convertToOption)}
                  classNamePrefix="previewSelectDevice"
                />
              </div>
            }
          </Row>
        }
      </React.Fragment>
    );
  }

  renderVideoIconAndSwitch = () => {
    return (
      <React.Fragment>
        <div className="d-flex modal-label mr-2">
          <img
            src={this.state.previewVideo ? video_on : video_off}
            className="previewSwitch"
          />
        </div>
        <div className="d-flex modal-label">
          {this.renderSwitch(this.state.previewVideo, CALLING_PREVIEW.PREVIEW_VIDEO)}
        </div>
      </React.Fragment>
    );
  }

  renderVideo = () => {
    return (
      <React.Fragment>
        <Row className="previewSetting mb-1 mx-0">
          <label className="label modal-label mr-4 mb-0">{getMessage("VIDEO")}</label>
          {isMobileOriPad() && !this.props.isLandscape && this.renderVideoIconAndSwitch()}
        </Row>
        { (!isMobileOriPad() || isMobileOriPad() && this.props.isLandscape ) &&
          <Row className="previewSetting mx-0 previewSettingIndent">
            {this.renderVideoIconAndSwitch()}
            {!isMobileOriPad() &&
              <div className="d-flex modal-label previewSelectDevice">
                <Select className="w-100"
                  value={this.convertToOption(this.state.selectedVideoDevice)}
                  onChange={this.handleVideoDeviceChange}
                  options={this.state.videoDeviceList.map(this.convertToOption)}
                  classNamePrefix="previewSelectDevice"
                />
              </div>
            }
          </Row>
        }
      </React.Fragment>
    );
  }

  renderVirtualBackbroundAnnotation = () => {
    return (
      <React.Fragment>
        <label className="label modal-label ml-3 mb-0 annotationMessage">{getMessage("OPERATION_MAY_BE_SLOW")}</label>
      </React.Fragment>
    );
  }

  render() {
    const isPreviewResize = this.props.isPreviewResize ? this.props.isPreviewResize.isEnable : false;
    const canStartSession = 
      this.props.sessionType !== SESSION_SUBTYPES.SUPPORT_CENTER ||
      !this.state.isAudioDeviceDisable

    return (
      <Modal 
        isOpen={this.props.show}
        className={isPreviewResize && this.props.orientation === DEVICE_ORIENTATION.LANDSCAPE 
          ? "previewVideoModal resize"
          : "previewVideoModal"}
        backdrop="static"
        centered={isPreviewResize}
      >
        <ModalBody>
          <label className="labelStyle prevLabel">
            {this.props.sessionType === SESSION_SUBTYPES.SUPPORT_CENTER ? getMessage("CALL_SETTINGS") : getMessage("SPEED_TEST_TEXT")}
          </label>

          <FormGroup className="center previewItemArea">
            <div className="previewSettingArea">
              {this.props.sessionType === SESSION_SUBTYPES.REGULAR && this.showSpeedTestPermissionPopUp()}
              {this.props.sessionType === SESSION_SUBTYPES.SUPPORT_CENTER ? this.renderMicrophone() : null}
              {/* {this.renderVideo()} */}
              { isMobileOriPad() &&
                <Row className="previewSetting mb-0 mx-0 previewSetting-switch hideElement">
                  <label className="label modal-label mr-4 mb-0">{getMessage("TOOLTIP_SWITCH_CAMERA")}</label>
                  <div className="d-flex modal-label mr-2">
                    <img
                      src={ic_switch_camera}
                      className="cameraSwitch"
                      onClick={this.handleSwitchCamera}
                    />
                  </div>
                </Row>
              }
              <Row className="previewSetting my-2 mx-0 previewSettingIndent previewSetting-reverse hideElement">
                <label className={this.state.facingMode === 'environment' ? "label modal-label mr-4 mb-0 colorGray" : "label modal-label mr-4 mb-0"}>{getMessage("TOOLTIP_REVERSE_CAMERA")}</label>
                <div className="d-flex modal-label mr-2">
                  {this.renderSwitch(
                    this.state.previewReverse,
                    CALLING_PREVIEW.PREVIEW_REVERSE,
                    this.state.facingMode === 'environment' ? true : false,
                  )}
                </div>
              </Row>
              {
                <React.Fragment>
                  <Row className="previewSetting my-2 mx-0 previewSettingIndent previewSetting-virtual hideElement">
                    <label className={this.state.isLoadingVideoStream ? "label modal-label mr-4 mb-0 colorGray" : "label modal-label mr-4 mb-0"}>{getMessage("VIRTUAL_BACKGROUND")}</label>
                    <div className="d-flex modal-label mr-2">
                      {this.renderSwitch(
                        this.state.previewVirtualBackground,
                        CALLING_PREVIEW.PREVIEW_VIRTUAL_BACKGROUND,
                        this.state.isLoadingVideoStream,
                      )}
                    </div>
                    { (!isMobileOriPad() || isMobileOriPad() && this.props.isLandscape ) && this.renderVirtualBackbroundAnnotation() }
                  </Row>
                  { (isMobileOriPad() && !this.props.isLandscape ) &&
                    <Row className="previewSetting my-2 mx-1 previewSettingIndent">
                      { this.renderVirtualBackbroundAnnotation() }
                    </Row>
                  }
                  <Row
                    className={
                      this.state.previewVirtualBackground
                        ? "previewSetting my-0 mx-0 previewSettingIndentBg hideElement"
                        : "previewSetting my-0 mx-0 previewSettingIndentBg disable previewBgDisable hideElement"
                    }
                  >
                    <div
                      className={ this.state.selectedBackground === FILTER_NAME.BLUR
                        ? "d-flex modal-label mr-1 mb-1 previewBgImage previewBgBlur previewBgImageBorder"
                        : "d-flex modal-label mr-1 mb-1 previewBgImage previewBgBlur"
                      }
                      onClick={() => { this.handleSetBackgroundImage(FILTER_NAME.BLUR) }}
                    >
                      <span className="previewBgBlurSpan">{getMessage("BLUR")}</span>
                    </div>
                    <div className="d-flex modal-label mr-1 mb-1">
                      <img
                        src={bg1}
                        className={ this.state.selectedBackground === FILTER_NAME.BG1
                          ? "previewBgImage previewBgImageBorder"
                          : "previewBgImage"
                        }
                        onClick={() => { this.handleSetBackgroundImage(FILTER_NAME.BG1) }}
                      />
                    </div>
                    <div className="d-flex modal-label mr-1 mb-1">
                      <img
                        src={bg2}
                        className={ this.state.selectedBackground === FILTER_NAME.BG2
                          ? "previewBgImage previewBgImageBorder"
                          : "previewBgImage"
                        }
                        onClick={() => { this.handleSetBackgroundImage(FILTER_NAME.BG2) }}
                      />
                    </div>
                    <div className="d-flex modal-label mr-1 mb-1">
                      <img
                        src={bg3}
                        className={ this.state.selectedBackground === FILTER_NAME.BG3
                          ? "previewBgImage previewBgImageBorder"
                          : "previewBgImage"
                        }
                        onClick={() => { this.handleSetBackgroundImage(FILTER_NAME.BG3) }}
                      />
                    </div>
                  </Row>
                </React.Fragment>
              }
            </div>
            <div className="previewVideoScreenArea">
              <div className="parentTagForIE hideElement">
                <video
                  data-object-fit="contain"
                  id={CALLING_PREVIEW.PREVIEW_VIDEO}
                  className={
                    this.state.facingMode === 'environment'
                      ? "videoScreen"
                      : "videoScreen flipVideo"
                  }
                  muted
                  autoPlay
                  playsInline
                  disablePictureInPicture
                >
                </video>
                { (!this.state.previewVideo || this.state.isVideoDeviceDisable) &&
                  <label className="videoScreenLabel alignItemsCenter justifyContentFlexCenter IEAcronym">
                    {getMessage("CAMERA_OFF")}
                  </label>
                }
                {(this.props.uniqueId && this.props.uniqueId === this.props.speedTestParticipantId) && (
                  <>
                    <div className="overlay"></div>
                    <label className="videoScreenLabel alignItemsCenter justifyContentFlexCenter IEAcronym">
                      {getMessage("VIDEO_WILL_BE_DISPLAYED_AFTER_SPEED_TEST")}
                    </label>
                  </>
                )}
              </div>
              {
                <SpeedTest
                  handleRerunSpeedtTest={this.handleRerunSpeedtTest}
                  isSpeedTestRunning={this.state.isSpeedTestRunning}
                />}
            </div>
          </FormGroup>
        </ModalBody>
        <ModalFooter className="permissionButtons">
          {(!this.props.isStart || !canStartSession) &&
            <Button
              className="buttons btn-decline customBtn"
              onClick={()=>this.handleCancelClick()}
            >
              {getMessage("CLOSE_WORD")}
            </Button>
          }
          <Button
            className={`${this.props.sessionType !== SESSION_SUBTYPES.SUPPORT_CENTER && !this.props.isStart ? 'hideElement' : ''} buttons btn-accept customBtn`}
            onClick={()=>this.handleStartClick()}
            disabled={!canStartSession}
          >
            { this.props.isStart
              ? this.props.sessionType === SESSION_SUBTYPES.SUPPORT_CENTER ? getMessage("START_CALL") : getMessage("START_CONNECT")
              : getMessage("APPLY")
            }
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  videoBandwidthSettings: getVideoBandwidthSettings(state),
  orientation: getDeviceOrientation(state),
  userRole: selectUserRole(state),
  uniqueId: selectCurrentParticipantUniqueId(state),
  speedTestParticipantId: getSpeedTestParticipantId(state),
  sessionKey: selectSessionKey(state),
  speedTestExecutedFlag: getSpeedTestExecutedFlag(state),
  userName: selectUserName(state),
  allParticipants: getAllParticipants(state),
  isPreviewResize: getIsPreviewResize(state),
  sessionType: state.SessionReducer.sessionSubType,
});

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      sendWebsocketMessage: sendWebsocketMessage,
    },
    dispatch
  );
};

export default modalScrollBar(withOrientationChange(connect(
  mapStateToProps,
  mapDispatchToProps,
)(PreviewModal)));
